import guest from "@/router/middleware/guest";

export const publicRoutes = [
    {
        path: '/auth',
        name: 'auth',
        component: () => import('@/pages/auth/AuthPage'),
        meta: {title: 'Авторизация', middleware: guest, public: true, onlyWhenLoggedOut: true},
    },
    {
        path: '*',
        name: '404',
        component: () => import('@/pages/errors/404'),
        meta: {title: 'Не найдено'},
    }
]
